var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparxLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 14,
    viewBox: "0 0 61 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.320312 11.4785L0.943818 10.7746C2.35745 12.0563 3.66066 12.6524 5.55168 12.6524C7.44269 12.6524 8.80144 11.587 8.80144 10.1421V10.1063C8.80144 8.7693 8.08537 7.99385 5.1662 7.416C2.08305 6.8024 0.83406 5.7728 0.83406 3.85855V3.8228C0.83406 1.94365 2.57829 0.5 4.96586 0.5C6.83836 0.5 8.06818 1.00505 9.37271 2.03465L8.76706 2.77435C7.55575 1.74475 6.34312 1.34825 4.92949 1.34825C3.03848 1.34825 1.78948 2.4136 1.78948 3.73245V3.7682C1.78948 5.10525 2.48704 5.91775 5.53515 6.5307C8.50853 7.1261 9.75753 8.17325 9.75753 10.0153V10.0511C9.75753 12.0921 7.97693 13.5 5.49878 13.5C3.44313 13.5 1.86354 12.8318 0.321635 11.4785H0.320312Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5762 7.76472V1.57087H17.2114C19.5249 1.57087 21.1032 2.61802 21.1032 4.62197V4.65772C21.1032 6.53557 19.4872 7.76342 17.101 7.76342H14.9799V8.62922H17.0468C19.7273 8.62922 22.0593 7.25642 22.0593 4.60247V4.56672C22.0593 2.12922 20.1127 0.703125 17.2855 0.703125H12.6221V13.3437H13.5768V8.63052",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3799 7.25837V1.57087H41.7669C44.099 1.57087 45.4564 2.63622 45.4564 4.33337V4.36912C45.4564 6.19302 43.8583 7.25837 41.7107 7.25837H38.7902V8.10662H41.5825L45.6766 13.3424H46.8879L42.647 7.94282C44.813 7.65422 46.4105 6.44392 46.4105 4.33207V4.29632C46.4105 3.39347 46.0435 2.54522 45.4379 1.94918C44.6663 1.18997 43.4007 0.703125 41.8211 0.703125H36.4238V13.3437H37.3786V8.10792",
    fill: "#1A1A1A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0386 6.89568L49.12 0.703125H50.2586L54.6456 6.28207L59.0148 0.703125H60.1355L55.197 6.89698L60.32 13.3437H59.1814L54.6099 7.51188L50.0563 13.3437H48.9355L54.0386 6.89698V6.89568Z",
    fill: "#1A1A1A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8174 2.5618L32.7578 12.4321H22.8644L27.8174 2.5618ZM27.8187 0.5L21.374 13.3434H34.2475L27.8187 0.5Z",
    fill: "url(#paint0_linear_26311_64185)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26311_64185",
    x1: 22.2832,
    y1: 14.1773,
    x2: 31.7763,
    y2: 6.03162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#652092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F54DE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FF83B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparxLogo);
export default __webpack_public_path__ + "static/media/sparx-logo.94e062a191942c678577c78dd2f91773.svg";
export { ForwardRef as ReactComponent };